import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import { Http, Response, Headers, RequestOptions, ResponseContentType } from '@angular/http';
import {environment} from '../../../../environments/environment';
import {CookieService} from 'ngx-cookie';
declare var DDP_ENV: any;
@Injectable({
  providedIn: 'root'
})
export class PackageServiceService {
  readonly baseURL = DDP_ENV.packageUrl;

  constructor(private _http: Http, private cookieService: CookieService) {}

  getAllPackages(page, status, size, regexPattern, deviceId) {
   const params = new HttpParams()
        .set('page', page)
        .set('status', status)
        .set('size', size)
        .set('deviceId', deviceId)
        .set('regexPattern', regexPattern );
    console.log('Inside get packages');
    return this._http.get(this.baseURL + '/package?' +
        'page=' + page +
        '&status=' + status +
        '&deviceType=' + deviceId +
        '&size=' + size +
        '&regexPattern=' + regexPattern,
        this.buildHeaders());
  }

    getPackageDetails(packageId) {
        console.log('Inside get package details');
        return this._http.get(this.baseURL + '/package/' + packageId, this.buildHeaders());
    }

  addUpdatePackage(packageData) {
    if (packageData.id === '') {
      return this._http.post(this.baseURL + '/package/', packageData, this.buildHeaders());
    } else {
      return this._http.put(this.baseURL + '/package/' + packageData.id, packageData, this.buildHeaders());
    }
  }

    /* Build request header */
    private buildHeaders(): any {
        const headers = new Headers({'Authorization': 'Bearer ' + this.cookieService.get('ecare_access_token')});
        return new RequestOptions({ headers: headers });
    }
}
